import { createFileRoute } from '@tanstack/react-router';
import { PlayScreen } from '@/components/game/PlayScreen';

/**
 * The way in. With a pod configured the screen opens on the lobby (ADR-076) — behind
 * the pass gate on a controlled-playtest pod, unless the browser is a signed-in,
 * funded account (ADR-099) — then a session is created and its socket opened. With
 * only a session WebSocket URL it joins that one session; with neither it runs the
 * in-browser demo replay, which is the design's own protocol fixtures played back.
 */
export const Route = createFileRoute('/play')({
  head: () => ({
    meta: [
      { title: 'Play — an Everwake session' },
      { name: 'description', content: 'Sit down with your AI game master: voice or text, sealed dice, a living kingdom. 18+.' },
      { name: 'robots', content: 'noindex' },
    ],
  }),
  component: PlayScreen,
});
